import { spacing } from '@moderneinc/design-system-tokens';
import { Box, Stack, Typography } from '@mui/material';
import type { FunctionComponent } from 'react';
import { ERROR_MESSAGES } from '../../../constants/error-messages';
import { createSupportEmailUrl } from '../../../helpers/link.helper';
import { Link } from '../moderne-link/moderne-link.component';
import { ErrorDetailsDisclosure } from './error-details-disclosure.component';

export const Error500: FunctionComponent<{
  subject: string;
  body: string;
  errorDetails?: string;
}> = ({ subject, body, errorDetails }) => {
  const supportUrl = createSupportEmailUrl({
    subject,
    body
  });

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          gap: `${spacing.spacing_4}px`
        }}
      >
        <Box
          component="img"
          src="/500.svg"
          alt="500"
          sx={{
            width: { xs: '15rem', sm: '20rem', md: '25rem' },
            height: { xs: '7.5rem', sm: '10rem', md: '12.5rem' },
            objectFit: 'contain'
          }}
        />

        <Stack
          sx={{
            alignItems: 'center',
            gap: `${spacing.spacing_3}px`,
            maxWidth: '31.25rem',
            textAlign: 'center'
          }}
        >
          <Typography variant="h3">
            {ERROR_MESSAGES.errorPages.serverError.title}
          </Typography>
          <Typography
            variant="body"
            sx={{ color: 'text.secondary', maxWidth: 480 }}
          >
            {ERROR_MESSAGES.errorPages.serverError.description}
          </Typography>
          <Link href={supportUrl}>Contact support</Link>
          {errorDetails && (
            <ErrorDetailsDisclosure errorDetails={errorDetails} />
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
